import { createAction } from "@reduxjs/toolkit";

export const appLoaded = createAction("APP_LOADED");
